/* eslint-disable no-param-reassign */

import taskTemplate from './task/taskTemplate';
import buttonsTemplate from './buttons/buttonsTemplate';

const init = function (instance) {
  function gridLineTemplate(task) {
    switch (task.type) {
    case instance.config.types.project:
    case instance.config.types.task:
    case instance.config.types.milestone:
      return taskTemplate(instance, task);
    case instance.config.types.button:
      return buttonsTemplate(instance, task);
    }

    return taskTemplate(instance, task);
  }

  instance.getVisibleTasksRange = function (instance, view, config, datastore, viewport) {
    const dataCount = instance.getVisibleTaskCount();
    const buffer = 1;
    const rowHeight = instance.config.row_height;
    const start = Math.floor(viewport.y / rowHeight) || 0;
    const end = Math.floor(viewport.y_end / rowHeight) || dataCount;
    const indexStart = Math.max(0, start - buffer);
    const indexEnd = Math.min(dataCount, end + buffer);

    return {
      start: indexStart,
      end: indexEnd,
    };
  };

  function wrapSmartRender(renderOne) {
    return function () {
      return {
        render: renderOne,
        update: null,
        getRectangle(item, view) {
          return {
            top: view.getItemTop(item.id),
            height: view.getItemHeight(item.id),
            left: 0,
            right: Infinity,
          };
        },
        getVisibleRange: instance.getVisibleTasksRange,
      };
    };
  }

  // Render task line in grid
  const renderOneGridLine = function (item) {
    return gridLineTemplate(item);
  };

  // Start point for gridLine
  instance.$ui.layers.gridLine = wrapSmartRender(renderOneGridLine);
};

export default {
  init,
};
